import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownRendererProps {
    content: string;
    className?: string;
}

/**
 * Renders markdown content as formatted HTML.
 * Used for displaying bounty descriptions and other markdown content.
 */
const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
    content,
    className = '',
}) => {
    if (!content) {
        return null;
    }

    return (
        <div data-color-mode="light" className={className}>
            <MDEditor.Markdown
                source={content}
                style={{
                    backgroundColor: 'transparent',
                    fontSize: '14px',
                    lineHeight: '1.6',
                }}
            />
        </div>
    );
};

export default MarkdownRenderer;
